import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "./DatePickerComponent.scss";

const propTypes = {
    id: PropTypes.string,
    classStyle: PropTypes.string,
    greyed: PropTypes.bool,
    placeholderT: PropTypes.string,
    startDateValue: PropTypes.object,
    canClear: PropTypes.bool,
};

export default class DatePickerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDateValue,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(date) {
        this.setState({startDate: date});
        this.props.onChange(this.props.id, date);
    }

    render() {
        //console.log('startDate', this.state.startDate);
        const {id, classStyle, greyed, placeholderT, startDateValue, canClear} = this.props;

        let disabledState = false;
        if (this.props.greyed === true) {
            disabledState = true;
        }


        return(
            <DatePicker
                className={this.props.classStyle}
                id={this.props.id}
                selected={this.state.startDate}
                onChange={this.handleChange}
                placeholderText= {this.props.placeholderT}
                isClearable={canClear}
                disabled={disabledState}
            />
        )
    }
}

DatePickerComponent.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/DatePickerComponent/index.js